import { createSlice } from "@reduxjs/toolkit";

// Create a slice for salesDatas
const salesDataSlice = createSlice({
  name: "salesData",
  initialState: {
    salesDataItems: [],
    salesData: {},
    loading: false,
    error: null,
  },
  reducers: {
    setSalesDataItems: (state, action) => {
      state.salesDataItems = action.payload.data || [];
      state.loading = false;
    },
    setSalesData: (state, action) => {
      state.salesData = action.payload.data || [];
      state.loading = false;
    },
  },
});

// Export the loading and error selectors if needed
export const selectSalesDataLoading = (state) => state.salesData.loading;
export const selectSalesDataError = (state) => state.salesData.error;
export const selectSalesDataItems = (state) => state.salesData.salesDataItems;
export const selectSalesData = (state) => state.salesData.salesData;

// Export the reducer to include in the store
export const { setSalesData, setSalesDataItems } = salesDataSlice.actions;
export default salesDataSlice.reducer;
